import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from 'Components/HeaderPlain';

const DailyReport = () => {
    const [loading, setLoading] = useState(true);
    const [matchingCount, setMatchingCount] = useState(0);
    const [stateEventData, setStateEventData] = useState([]);

    useEffect(() => {
        const getCount = async () => {
            setLoading(true);
            try {
                const response = await fetch('https://ecoclubs.education.gov.in/api/report-state-count', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({})
                });

                const result = await response.json();

                if (result.status === 'success') {
                    const counts = result.data[0];
                    setMatchingCount(counts.matchingCount - 2);

                    const stateWiseEventCreatedAllTime = counts?.allTime || [];
                    const stateWiseEventCreatedLast24Hrs = counts?.last24Hours || [];

                    const last24HrMap = {};
                    stateWiseEventCreatedLast24Hrs.forEach(item => {
                        last24HrMap[item.state] = item.count;
                    });

                    const formattedStateWiseEvent = stateWiseEventCreatedAllTime
                        .map(item => ({
                            state: item.state,
                            count: item.count,
                            last24HoursCount: last24HrMap[item.state] || 0
                        }))
                        .sort((a, b) => a.state.localeCompare(b.state));

                    setStateEventData(formattedStateWiseEvent);
                }
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        getCount();
    }, []);

    return (
        <>
            <Header />
            <div className="container mt-5" style={{ paddingBottom: '110px' }}>
                <h3 className="text-center"><strong>Total Events Created</strong></h3>
                <h4 className="text-center text-primary" style={{ color: 'black', WebkitTextFillColor: 'black' }}>
                    <span>
                        Total Events:&nbsp;
                        <strong>
                            {stateEventData.reduce((total, stateItem) => total + stateItem.count, 0)}
                        </strong>
                    </span>
                </h4>

                <div className="mt-5">
                    <h4><strong>States/UTs/ABs-wise Events Created</strong></h4>
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>States/UTs/ABs</th>
                                <th className="text-center">Events Created (All Time)</th>
                                <th className="text-center">Events in Last 24 Hours</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="4" className="text-center">Loading...</td>
                                </tr>
                            ) : (
                                <>
                                    {stateEventData.length > 0 ? stateEventData.map((stateItem, index) => (
                                        <tr key={stateItem.state}>
                                            <td>{index + 1}</td>
                                            <td>{stateItem.state}</td>
                                            <td className="text-center">{stateItem.count}</td>
                                            <td className="text-center">{stateItem.last24HoursCount || 0}</td>
                                        </tr>
                                    )) : (
                                        <tr>
                                            <td colSpan="4" className="text-center">No state data found</td>
                                        </tr>
                                    )}
                                    <tr style={{ fontWeight: 'bold', backgroundColor: '#f8f9fa' }}>
                                        <td colSpan="2" className="text-right">Total</td>
                                        <td className="text-center">
                                            {stateEventData.reduce((total, stateItem) => total + stateItem.count, 0)}
                                        </td>
                                        <td className="text-center">
                                            {stateEventData.reduce((total, stateItem) => total + (stateItem.last24HoursCount || 0), 0)}
                                        </td>
                                    </tr>
                                </>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default DailyReport;
